import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private currentEnv: any;

  constructor() {
    // Initialize with default environment, if necessary
    this.currentEnv = environment.global; // Or some logic to choose default
  }

  public getEnv(loginId: string, code: string) {
    if (loginId?.toLowerCase() === 'beta') {
      this.currentEnv = environment.global; // BETA
    } else {
      // default environment - BETA
      this.currentEnv = environment.global;
    }
    return this.currentEnv;
  }

  setEnvironmentForUser(loginId: string, code: string): void {
    this.getEnv(loginId, code);
    localStorage.setItem('loginUser', loginId);
    localStorage.setItem('loginCode', code);
  }

  get currentEnvironment() {
    let loginUserDetails = localStorage.getItem('loginUser') ?? '';
    let loginUserCode = localStorage.getItem('loginCode') ?? '';
    return this.getEnv(loginUserDetails, loginUserCode);
  }
}
